import { cn } from "@ronin/ui";

/** Brand mark: a flat blue "R" on a dark tile (same as favicon.svg; DESIGN.md: Brand mark). */
export function BrandMark({ className }: { className?: string }) {
  return <img src="/icon-192.png" alt="" aria-hidden className={cn("size-10", className)} />;
}

/** Wordmark used in the top bar. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("text-xs font-semibold tracking-wide text-foreground", className)}>
      RONIN
    </span>
  );
}
